import React, { useState } from 'react'
import owner from "../../asstes/avatar-13-vector-42526238.avif"
import { FaChevronDown, FaCopy, FaLongArrowAltUp } from "react-icons/fa";
import { ImNotification } from "react-icons/im";
import frgImg from "../../asstes/frgx.webp"
// import icon from "../../asstes/activity_white.webp"
import partnership from "../../asstes/partnership.png"
import UserTeam from "../../asstes/team.png"
import Ratioimg from "../../asstes/ratio.png"
import BrandLogo from '../../asstes/logo.jpg'

import cup from "../../asstes/cup.svg"
import RecentPlatfrom from './RecentPlatfrom';
import MembersTotalBox from './MembersTotalBox';
import { MdDashboard } from "react-icons/md";
import { RiTeamFill } from "react-icons/ri";
import { FaAngleDown } from "react-icons/fa6";
import { AiOutlineTeam, AiFillSlackCircle } from "react-icons/ai";
import { MdTransferWithinAStation } from "react-icons/md";
import { FaTelegramPlane, FaTwitter, FaInstagramSquare, FaYoutube } from "react-icons/fa";
import { useDispatch, useSelector } from 'react-redux';
import Forsaggex from './Forsagex3Page'
import PartnersTable from '../Partners/PartnersTable';
import { setselectedComponent } from '../Store/UserSlice';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Forsagex3Details from './Forsagex3Details';
import { PiSignInBold } from "react-icons/pi";
import { useNavigate } from 'react-router-dom';

const DashBoard = () => {
  const [show, setShow] = useState(true);
  const [isOpen, setIsOpen] = useState(true);
  const [copied, setCopied] = useState(false);
  const ApiUrl = process.env.REACT_APP_API;
  const dispatch = useDispatch()

  const handleHide = () => {
    setShow(!show);
  }

  const handleIsopen = () => {
    // setIsOpen(!isOpen);
  }

  const handleCopy = () => {
    // const textToCopy = document.querySelector('.text-to-copy').ReferalLink;
    const textToCopy = ReferalLink;

    if (navigator.clipboard) {
      navigator.clipboard.writeText(textToCopy)
        .then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 1000);
        })
        .catch(err => console.error('Could not copy text: ', err));
    } else {
      const textArea = document.createElement('textarea');
      textArea.value = textToCopy;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 1000);
    }
  };

  const UserData = useSelector(state => state.user.UserData)
  console.log("UserData", UserData)

  const timestamp = UserData?.user?.time;
  const date = new Date(timestamp * 1000);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  const formattedDate = `${year}-${month}-${day}`;


  const CopyAddress = (address) => {
    navigator.clipboard.writeText(address)
      .then(() => {
        toast.success('Address copied to clipboard!');

      });
  };
  const userReferralCode = UserData?.user?.userReferralCode;

  // const ReferalLink = `http://localhost:3000/Register?userReferralCode=${userReferralCode}`;

  const shortLink = `https://short.link/${userReferralCode}`

  const baseUrl = "https://myreview.website/GainApex2/Register/userReferralCode=";
  // const baseUrl = "http://localhost:3000/GainApex2/Register/userReferralCode=";
  const ReferalLink = baseUrl + userReferralCode;



  const selectedComponent = useSelector(state => state.user.selectedComponent);

  const ComponentSelection = (component) => {
    dispatch(setselectedComponent(component));
  }

  const navigate = useNavigate()

  const GotoRegister = () => {
    navigate("/register")
  }

  return (
    <>
      <div className='w-full main_body_color  dashbord_full_body'>
        <div className="flex main_body_color w-full">
          <aside className="main_body_color fixed w-[25%] lg:sticky top-28   whitespace-nowrap  lg:block hidden  shadow-xl Dashbord_SideBar_border">
            <div className='px-8'>
              {/* <img src={BrandLogo} width={"100px"} className='Brand_logo'/> */}
              <section className={`brightness-125 py-3 mt-5  mb-7  Dashbord_side_section px-3 rounded-xl flex flex-col ${selectedComponent === "Dashbord" ? "dashbord_side_Bar" : "bg-[#212121]"}`}>
                <p className='flex gap-3 items-center text-white' onClick={() => ComponentSelection("Dashbord")}>
                  <span><MdDashboard size={20} /></span>
                  <span>DashBoard</span>
                </p>
              </section>
              <section className={`brightness-125 py-3 mt-5 mb-7  
              Dashbord_side_section px-3 rounded-xl flex flex-col ${selectedComponent === "Register" ? "dashbord_side_Bar" : "bg-[#212121]"}`}>

                <p className='flex gap-3 items-center text-white' onClick={GotoRegister}>

                  <span><PiSignInBold size={20} /></span>
                  <span>Register</span>
                </p>
              </section>

              <div className=''>
                <section className=' py-3   mb-7 
                Dashbord_side_section hover:text-white px-3  rounded-xl flex flex-col bg-[#212121] '>
                  <ul className='flex gap-20  items-center justify-between text-white '>
                    <li className='flex gap-2  items-center Dashbord_side_section'>
                      <span><RiTeamFill size={20} />
                      </span><span>Team</span>
                    </li>
                    <li className=' cursor-pointer' onClick={handleIsopen}><FaAngleDown size={15} /></li>
                  </ul>

                </section>
                {
                  isOpen ? (
                    <section className='brightness-125 overflow-hidden text-white bg-[#212121] rounded-xl flex flex-col'>
                      <p
                        className={`${selectedComponent === "PartnerTable" ? "dashbord_side_Bar" : "bg-[#212121]"} flex cursor-pointer gap-3 py-3 px-3 items-center Dashbord_side_section`}
                        onClick={() => ComponentSelection("PartnerTable")}
                      >
                        <span><AiOutlineTeam size={20} /></span>
                        <span>Partners</span>
                      </p>
                      {/* 
  <p className='flex cursor-pointer gap-3 py-2 px-3 items-center'>
    <span><MdTransferWithinAStation size={20} /></span><span>Links</span>
  </p>
  <p className='flex cursor-pointer gap-3 py-2 px-3 items-center'>
    <span><AiFillSlackCircle size={20} /></span><span>Stats</span>
  </p> 
  */}
                    </section>

                  ) : ""
                }
              </div>

            </div>
            <div className='px-8 fixed bottom-4'>
              <div className='flex items-center text-white mx-auto gap-4'>
                <p className=' rounded-full p-2 cursor-pointer bg-gray-600 hover:bg-gray-700'><FaTelegramPlane /></p>
                <p className=' rounded-full p-2 cursor-pointer bg-gray-600 hover:bg-gray-700'><FaTwitter /></p>
                <p className=' rounded-full p-2 cursor-pointer bg-gray-600 hover:bg-gray-700'><FaInstagramSquare /></p>
                <p className=' rounded-full p-2 cursor-pointer bg-gray-600 hover:bg-gray-700'><FaYoutube /></p>
              </div>
            </div>
          </aside>

          {selectedComponent === "Dashbord" &&
            <div className="w-full">
              <main className="px-6 py-8 pb-0 lg:px-8 main_body_color flex flex-col gap-6 ">
                <div className='md:grid md:grid-cols-2 lg:grid lg:grid-cols-2 p-4 Box_Backgrounds h-fit '>
                  <section className="  px-2 shadow rounded flex flex-col gap-10">
                    <div className="flex gap-6 items-center">
                      <div className='Dashbord_profile_id'>
                        <div className="p-1 rounded-full Main_GradienTCoilor " >
                          <img className=' object-cover Profile_image rounded-full ' src={UserData?.user?.photo == null ? owner : UserData?.user?.photo} alt="unknowImg" />
                        </div>
                        <p className='text-white font-medium text-2xl Main_GradienTCoilor px-3  rounded-md'>ID {UserData?.user?.userId}</p>
                      </div>
                      <div className="w-full flex flex-col items-start gap-3">
                        <p className='text-white text-2xl font-bold'>{UserData?.user?.name || "Name Not Found"}</p>
                        <span className='text-white  font-bold'>{UserData?.user?.email || "Email Not Found"}</span>
                        {/* <p className='text-blue-600 font-medium text-xl'>ID {UserData?.user?.userId}</p> */}
                        <div className='text-white hidden md:block lg:block'>
                          <p className='flex gap-2' >
                            {`${UserData?.user?.userAddress?.slice(0, 10) + "..." + UserData?.user?.userAddress?.slice(-3)}`}
                            <span className=' cursor-pointer'>
                              <FaCopy size={20} onClick={() => CopyAddress(UserData?.user?.userAddress)} />


                            </span></p>
                          <p className='text-gray-300 py-2 flex invited_id'>invited {formattedDate} by <span className=' ml-2 px-4 py-1 cursor-pointer rounded-[7px] bg-[#212121] Main_GradienTCoilor  flex'>ID  {UserData?.user?.referrer_userId}
                            <FaLongArrowAltUp size={20} color='white' />
                          </span>

                          </p>

                        </div>
                        <button onClick={handleHide} className='main_body_color md:hidden lg:hidden  flex items-center   font-medium w-full text-gray-300 rounded-[20px]  px-10 py-1'> <span className='ml-12'>Show more</span> <span className='mx-auto'><FaChevronDown size={15} /></span></button>
                      </div>
                    </div>
                    {
                      show ?
                        ""
                        : (
                          <div className='text-white'>
                            <p className='flex gap-2' >0xa0A1...eb41 <span className=' cursor-pointer'><FaCopy size={20} /></span></p>
                            <p className='text-gray-300 py-2 '>invited 24.04.2024 by <span className=' ml-2 px-4 py-1 cursor-pointer rounded-[15px] bg-[#212121] text-blue-600'>ID 1</span></p>
                          </div>
                        )
                    }
                  </section>

                  <div className=''>
                    <section className=' mt-5 md:grid md:grid-cols-2 lg:grid  Personal_link_section lg:grid-cols-2 mb-5 bg-[#2b334d]   shadow rounded-xl flex flex-col gap-5 h-28 Refferal_box px-3'>
                      <div className='flex md:block justify-between items-center px-2'>
                        <p className='text-white text-sm flex gap-3  pb-2 items-center'>Personal link <span><ImNotification /></span> </p>
                        <p className='text-white font-bold text-to-copy copy'>{shortLink}</p>
                      </div>
                      <button className='w-60 rounded-[10px] hover:bg-blue-500 py-3 font-bold px-10 AllBackgrounds text-white button-name COpY_address_link ' onClick={handleCopy}>
                        {copied ? 'Copied!' : 'Copy'}
                      </button>
                    </section>
                    {/* <section className=' relative'>
                      <img className=' rounded-xl hover:bg-[#212121]' src={frgImg} alt="frgImg" />
                      <p className='text-white md:hidden lg:block hidden absolute top-5 left-[45%]'>FRGX Token</p>
                      <button className='py-1  text-sm absolute right-6 top-2  px-3 lg:w-32 lg:mt-0   md:w-44 md:mt-1 rounded-[20px] border-2 border-gradient-to-r text-white'>Login to show balance</button>
                    </section> */}
                  </div>
                </div>
                <div className=' md:block md:justify-evenly md:gap-4 lg:block lg:justify-evenly lg:gap-4'>
                  <div className='flex justify-evenly align-center py-6 '>
                    <section className=' rounded-xl Box_Backgrounds Profit_section w-full p-4'>
                      <p className='text-white py-3'>Profits</p>
                      <div className='flex justify-between px-3 text-white items-center'>
                        <p className=' flex gap-2 items-center font-bold text-2xl'>{UserData?.user?.profit?.toFixed(4)} <span className='font-bold'>BUSD</span></p>
                        <p className='flex text-white text-sm items-center gap-1 text-[#30E000]'><FaLongArrowAltUp /><span className='text-xl text-white'>0</span></p>
                      </div>
                      {/* <div className='flex justify-between px-3 py-2 text-white items-center'>
                    <p className=' flex gap-2 items-center font-bold text-2xl'>{UserData.user.profit}<span className='font-bold'>BNB</span></p>
                    <p className='flex text-white text-sm items-center gap-1'><FaLongArrowAltUp /><span className='text-xl'>0</span></p>
               text-white    </div> */}
                    </section>
                    <div className='flex px-5  w-full justify-between items-center gap-3'>
                      <section className='py-2 w-full rounded-xl px-3 Box_Backgrounds'>
                        <p className='text-white'>Partners</p>
                        <p className=' font-bold text-2xl py-3 text-white'>{UserData?.user?.partners}</p>
                        <div className='py-2 flex items-center justify-between  rounded-[20px] px-3 Dashbord-Icons_background'>
                          <p className='flex text-sm items-center gap-1 text-[#30E000]'><FaLongArrowAltUp /><span className='text-xl text-white'>0</span></p>
                          <img src={partnership} alt="icon" width={"40px"} />
                        </div>
                      </section>
                      <section className='py-2  w-full rounded-xl px-3 Box_Backgrounds'>
                        <p className='text-white'>User Teams</p>
                        <p className=' font-bold text-2xl py-3 text-white'>{UserData?.user?.userTeamCount}</p>
                        <div className='py-2 flex items-center justify-between  rounded-[20px] px-3 Dashbord-Icons_background  Dashbord_Ration_color'>
                          <p className='flex text-sm items-center gap-1  text-[#30E000]'><FaLongArrowAltUp /><span className='text-xl text-white'>0</span></p>
                          <img src={UserTeam} alt="icon" width={"40px"} />
                        </div>
                      </section>
                    </div>
                  </div>
                  <section className='py-2 flex justify-between items-center  w-full rounded-xl px-3 Box_Backgrounds h-28'>
                    <p className='text-white text-2xl'>Ratio</p>
                    <p className='text-white font-bold text-2xl'>0 %</p>
                    <div className='py-2 flex w-1/2 items-center justify-between  rounded-[20px] px-3 Dashbord-Icons_background  '>
                      <p className='flex  text-red  items-center  gap-1 h-12  text-[#30E000]'><FaLongArrowAltUp /><span className='text-xl text-white'>0</span></p>
                      <img src={Ratioimg} alt="icon" width={"40px"} />
                    </div>
                  </section>
                </div>

              </main>
              {/* <div className='md:px-8 lg:px-10 '>
              <section className='py-2 md:rounded-xl lg:rounded-xl my-5 w-full px:mx-10   bg-[#212121]'>
                <div className='flex justify-between md:flex  md:items-center md:justify-between md:px-12 lg:flex  lg:items-center lg:justify-between lg:px-12 mx-auto items-center'>
                  <img className='w-24 object-cover' src={cup} alt="" />
                  <img className='w-24 object-cover' src={cup} alt="" />
                  <img className='w-24 object-cover' src={cup} alt="" />
                  <img className='w-24 object-cover' src={cup} alt="" />
                  <p className='text-center hidden md:block lg:block font-bold cursor-pointer text-gray-400'>Show all</p>
                </div>
                <p className='text-center md:hidden lg:hidden font-bold cursor-pointer text-gray-400'>Show all</p>
              </section>
            </div> */}

              {/* --- forsage programs sections start here --- */}
              <div className='flex  items-center gap-3 px-8 py-3 pt-12'>
                <h1 className='text-white font-bold text-2xl'>Forsage x3 Programs </h1>
                <span className='text-white px-3 py-1 rounded-[10px] flex gap-2 items-center AllBackgrounds '><ImNotification size={20} />Info</span>
              </div>
              <Forsaggex />
              <Boxs />

              {/* --- forsage programs sections end here --- */}
            </div>
          }


          {
            selectedComponent === "PartnerTable" && <div className='Main_page_Componets'><PartnersTable /></div>
          }

          {
            selectedComponent === "Forsagex3Details" && <div className='Main_page_Componets'><Forsagex3Details /></div>
          }
        </div>
      </div>
    </>
  )
}

export default DashBoard



const Boxs = () => {
  const box = [{ text: "x3", busdText: "0 BUSD" }];
  const data = ["", "", "", "", null, null, null, null, null, null];

  return (
    <>
      <div className="w-full px-2 md:px-5 ">
        {/* <section className="py-4 w-full px-4 rounded-xl  bg-[#212121]">
          {
            <div className="py-4 flex flex-wrap gap-4 md:flex-wrap md:w-1/2 lg:w-1/2 lg:flex-wrap ">
              {data.map((item, index) => (
                <p
                  key={index}
                  className={
                    item === ""
                      ? "bg-blue-600 py-10 px-10 rounded-xl"
                      : "bg-[#555] py-10 px-10 rounded-xl"
                  }
                >
                  {item}
                </p>
              ))}
            </div>
          }
          <button className="bg-blue-600 w-full text-white py-3 px-5 rounded-xl hover:bg-blue-500 font-medium">
            Preview
          </button>
        </section> */}
        <div className=" 
        md:grid  md:grid-cols-1
         sm:grid  sm:grid-cols-1 
         lg:grid  lg:grid-cols-2
        Recenet_plateform ">
          <div className="
            order-last lg:order-first md:order-first px-3 md:px-3 my-5
            Box_Backgrounds rounded-xl">
            <RecentPlatfrom />
          </div>
          <div className="md:px-16 lg:px-20">
            <MembersTotalBox />
          </div>
        </div>
        <div className="py-10">
          {/* <p className="text-white text-sm ">© 2024 All Rights Reserved</p> */}
        </div>
      </div>
      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        // pauseOnFocusLoss
        draggable
        // pauseOnHover
        theme="light"
      />

    </>
  );
};